import { VU } from "./VU";

export class Ω extends VU {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      scales: ["µ", "m", "", "k", "M"],
      unit: "Ω",
      size: 6
    };
  }
}
